(function() {
  // =====================================================
  // CONFIGURATION - URLs des images de guide
  // Format: 'taille|forme|type': 'URL'
  // type = 'interieur' ou 'exterieur'
  // =====================================================
  /* CASEMIRA C8 1.10 : les images ci-dessous partaient a leur taille d'origine,
     2048 x 1790, soit 331 Ko pour la plus vue (160x230cm.webp), alors qu'elles
     s'affichent dans une boite de 380 px (MESURE 3.9 : 331 Ko servis pour
     380 x 332). La balise porte `max-width: 100%; height: auto` et AUCUNE
     largeur CSS : sa largeur de rendu est donc min(largeur intrinseque, boite).
     Tant que la largeur servie reste au-dessus de la boite, la mise en page est
     rigoureusement identique. 1200 px couvre un ecran en densite 3 sur une boite
     de 380 px (1140) et laisse une marge confortable si la boite s'elargit un
     jour : 129 Ko au lieu de 331, sans un pixel de difference.
     On n'ajoute pas de srcset ici : sur une image sans largeur CSS, un srcset en
     descripteurs `w` fixe la largeur de rendu a la valeur de `sizes`, ce qui
     changerait la mise en page. Une seule URL, bornee, est le geste sur. */
  const LARGEUR_GUIDE = 1200;
  function bornerLargeur(url) {
    if (!url || url.indexOf('width=') !== -1) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + LARGEUR_GUIDE;
  }

  const guideImages = {
    // RECTANGULAIRE - Intérieur
    '160 x 230|rectangulaire|interieur': 'https://cdn.shopify.com/s/files/1/0976/8301/4015/files/160x230cm.webp?v=1769041511',
    '200 x 300|rectangulaire|interieur': 'https://cdn.shopify.com/s/files/1/0976/8301/4015/files/200x300cm.webp?v=1769041511',
    '200 x 240|rectangulaire|interieur': 'https://cdn.shopify.com/s/files/1/0976/8301/4015/files/200x240cm.webp?v=1769041510',
    
    // RECTANGULAIRE - Extérieur
    '160 x 230|rectangulaire|exterieur': 'https://cdn.shopify.com/s/files/1/0976/8301/4015/files/160x230cm_exterieur.webp?v=1769041511',
    '200 x 290|rectangulaire|exterieur': 'https://cdn.shopify.com/s/files/1/0976/8301/4015/files/200x290cm_exterieur.webp?v=1769041511',
    
    // OVALE - Intérieur
    '160 x 230|ovale|interieur': 'https://cdn.shopify.com/s/files/1/0976/8301/4015/files/Ovale_160x230cm.webp?v=1769041511',
    '200 x 300|ovale|interieur': 'https://cdn.shopify.com/s/files/1/0976/8301/4015/files/Ovale_200x300cm_2.webp?v=1769041511',
    
    // ROND - Intérieur
    '160|rond|interieur': 'https://cdn.shopify.com/s/files/1/0976/8301/4015/files/200cm_diametre_rond.webp?v=1769041511',
    '200|rond|interieur': 'https://cdn.shopify.com/s/files/1/0976/8301/4015/files/200cm_diametre_rond.webp?v=1769041511',
    '250|rond|interieur': 'https://cdn.shopify.com/s/files/1/0976/8301/4015/files/250cm_diametre_rond.webp?v=1769041511',
    
    // ROND - Extérieur
    '160|rond|exterieur': 'https://cdn.shopify.com/s/files/1/0976/8301/4015/files/160cm_diametre_rond_exterieur.webp?v=1769041511',

    // =====================================================
    // AJOUTER DE NOUVELLES TAILLES ICI
    // Format: 'taille|forme|type': 'URL',
    // =====================================================
  };

  // Collection extérieur (handle)
  const collectionExterieur = 'tapis-dexterieur';

  // =====================================================
  // NE PAS MODIFIER EN DESSOUS
  // =====================================================

  /* i18n R2b : table lue UNE fois, repli code (CONVENTION.md § 3). Le libelle
     est la MEME cle que l'attribut `alt` pose par snippets/variant-guide-image.liquid :
     une cle, deux consommateurs (CONVENTION.md § 5). */
  const S = (window.FoxTheme && window.FoxTheme.casemira && window.FoxTheme.casemira.fiche) || {};

  let productData = null;

  function getProductData() {
    if (productData) return productData;
    
    // Cherche les données dans les scripts JSON (méthode Hyper)
    const scripts = document.querySelectorAll('script[type="application/json"]');
    for (const script of scripts) {
      try {
        if (script.textContent.includes('variants')) {
          const data = JSON.parse(script.textContent);
          if (data.variants && Array.isArray(data.variants)) {
            productData = data;
            return productData;
          }
        }
      } catch (e) {
        // Ignore les erreurs de parsing
      }
    }
    return null;
  }

  function normalizeText(text) {
    if (!text) return '';
    return text
      .toLowerCase()
      .trim()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function isExterieur() {
    const url = window.location.href.toLowerCase();
    const referrer = document.referrer.toLowerCase();
    
    if (url.includes(collectionExterieur) || referrer.includes(collectionExterieur)) {
      return true;
    }
    
    const product = getProductData();
    if (product) {
      // Vérifie les tags
      if (product.tags) {
        const tags = Array.isArray(product.tags) ? product.tags : product.tags.split(',');
        if (tags.some(t => normalizeText(t).includes('exterieur') || normalizeText(t).includes('outdoor'))) {
          return true;
        }
      }
      // Vérifie le titre
      if (product.title && (normalizeText(product.title).includes('exterieur') || normalizeText(product.title).includes('outdoor'))) {
        return true;
      }
    }
    
    return false;
  }

  function getSelectedVariant() {
    const product = getProductData();
    if (!product || !product.variants) return null;

    // Méthode 1: Via l'URL
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');
    
    if (variantId) {
      const variant = product.variants.find(v => v.id == variantId);
      if (variant) return variant;
    }
    
    // Méthode 2: Via le drawer/sélecteur Hyper - lit l'option sélectionnée
    const triggerSummary = document.querySelector('.vd-trigger__summary, [data-vd-summary]');
    if (triggerSummary) {
      const summaryText = triggerSummary.textContent.trim();
      // Le format est "Forme · Taille — Prix" ex: "Rectangulaire · 160 x 230 — 459,00€"
      const variant = product.variants.find(v => {
        const title = v.title || v.public_title || '';
        // Vérifie si le résumé contient les infos de la variante
        return summaryText.includes(v.option1) || summaryText.includes(v.option2);
      });
      if (variant) return variant;
    }

    // Méthode 3: Première variante disponible
    return product.variants.find(v => v.available !== false) || product.variants[0];
  }

  function updateGuideImage() {
    const img = document.getElementById('variant-guide-image');
    if (!img) return;

    const variant = getSelectedVariant();
    if (!variant) {
      img.style.display = 'none';
      console.log('[Guide Image] Aucune variante trouvée');
      return;
    }

    // Récupère taille et forme depuis les options
    const taille = variant.option1 || '';
    const forme = normalizeText(variant.option2 || 'rectangulaire');
    const type = isExterieur() ? 'exterieur' : 'interieur';

    // Construit la clé pour trouver l'image
    const imageKey = `${taille}|${forme}|${type}`;
    
    console.log('[Guide Image] Recherche:', imageKey);
    
    // Cherche l'image
    let imageUrl = guideImages[imageKey];
    
    // Fallback: essaie avec l'autre type si pas trouvé
    if (!imageUrl) {
      const fallbackType = type === 'exterieur' ? 'interieur' : 'exterieur';
      const fallbackKey = `${taille}|${forme}|${fallbackType}`;
      imageUrl = guideImages[fallbackKey];
      if (imageUrl) {
        console.log('[Guide Image] Fallback utilisé:', fallbackKey);
      }
    }

    // Met à jour l'image
    if (imageUrl) {
      img.src = bornerLargeur(imageUrl);
      img.alt = (S.guideProportions || 'Guide des proportions') + ` - ${taille} ${forme}`;
      img.style.display = 'block';
      console.log('[Guide Image] Image affichée:', imageUrl);
    } else {
      img.style.display = 'none';
      console.log('[Guide Image] Aucune image pour:', imageKey);
    }
  }

  function init() {
    // Attendre que les données soient chargées
    let attempts = 0;
    const maxAttempts = 20;
    
    const tryInit = () => {
      attempts++;
      const product = getProductData();
      
      if (product) {
        console.log('[Guide Image] Données produit trouvées');
        updateGuideImage();
        setupListeners();
      } else if (attempts < maxAttempts) {
        setTimeout(tryInit, 250);
      } else {
        console.log('[Guide Image] Données produit non trouvées après', maxAttempts, 'tentatives');
      }
    };
    
    tryInit();
  }

  function setupListeners() {
    // Écoute les changements d'URL
    let lastUrl = window.location.href;
    setInterval(() => {
      if (window.location.href !== lastUrl) {
        lastUrl = window.location.href;
        setTimeout(updateGuideImage, 100);
      }
    }, 200);

    // Écoute les événements du thème
    document.addEventListener('variant:changed', updateGuideImage);
    document.addEventListener('variantChange', updateGuideImage);
    
    // Écoute les clics sur le sélecteur de variantes Hyper
    document.addEventListener('click', (e) => {
      const target = e.target.closest('.vd-trigger, .variant-picker, [data-variant], .product-form__option, .vd-option');
      if (target) {
        // Attendre que le drawer se ferme et que l'URL soit mise à jour
        setTimeout(updateGuideImage, 500);
      }
    });

    // Observer les mutations du DOM pour détecter les changements de variante
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          const target = mutation.target;
          if (target.classList && (
            target.classList.contains('vd-trigger__summary') ||
            target.closest && target.closest('.vd-trigger')
          )) {
            setTimeout(updateGuideImage, 100);
          }
        }
      }
    });

    const triggerElement = document.querySelector('.vd-trigger, .product-form__variants');
    if (triggerElement) {
      observer.observe(triggerElement, { 
        childList: true, 
        subtree: true, 
        characterData: true 
      });
    }
  }

  // Démarre quand le DOM est prêt
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
